import AdminSettingsPage from "./AdminSettingsPage";

export default AdminSettingsPage;
